import React from 'react';
import { Box, Divider, Modal, Theme, Typography, useMediaQuery } from '@mui/material';
import { MuiButton } from '../Button'; // assuming this is your styled MUI button
import { palette } from '@/theme/constants';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  data: any;
  onClose: () => void;
  onCreateAccount: () => void;
};

export const SaveMemoryPopup = ({ open, onClose, onCreateAccount }: Props) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        width={isMobile ? '90%' : '38.1875rem'}
        height={'100%'}
        minHeight={'12rem'}
        maxHeight={'14rem'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        alignContent={'center'}
        padding={isMobile ? '1rem' : '1.5rem'}
        borderRadius={'1.25rem'}
        justifyContent={'space-between'}
        position={'relative'}
        bgcolor={palette.cardBackground}
        sx={{
          backdropFilter: 'blur(1.5625rem)',
          border: `0.063rem solid ${palette.cardBorder}`,
          margin: 'auto',
          top: '25%',
        }}>
        <Typography
          mt={isMobile ? '0' : '1rem'}
          sx={{
            fontSize: '1rem',
            fontWeight: 'bold',
            display: 'flex',
            textAlign: 'center',
            alignContent: 'center',
            alignItems: 'center',
          }}>
          {t('In order to save and submit your memory, please create a free account.')}
        </Typography>

        <Divider sx={{ backgroundColor: palette.dirtyWhite, width: '100%' }} />

        <Box display='flex' justifyContent='center' gap={2} flexDirection={isMobile ? 'column' : 'row'}>
          <MuiButton type='button' loading={false} variant={'contained'} method={onClose}>
            <Typography variant='button' width={330} color={palette.white}>
              No thanks, don’t save
            </Typography>
          </MuiButton>

          <MuiButton type='button' loading={false} variant={'contained'} method={onCreateAccount}>
            <Typography variant='button' color={palette.white}>
              Create Free Account
            </Typography>
          </MuiButton>
        </Box>
      </Box>
    </Modal>
  );
};
